export default __webpack_public_path__ + "static/media/process_3.42e7ae12.png";